// @flow

export const edgeStyle = {
  labelStyle: {
    fontFamily: 'Menlo',
  },
  labelBgStyle: {
    fill: '#F6F8FA',
    filter: 'drop-shadow(-1px 1px 1px rgb(60 66 87 / 8%))',
  },
};
